const handleUpdatePostSubmitQuestionnaire = ({
  callback,
  formData,
  updateUserProfile
}) => async (overrideAnswers = {}) => {
  if (formData || overrideAnswers) {
    try {
      const {
        data: { update_user_profile = {} } = {}
      } = await updateUserProfile({
        variables: {
          input: {
            ...formData,
            ...overrideAnswers,
            source: "expert_post_contact"
          }
        }
      });

      if (update_user_profile.errors) {
        throw update_user_profile.errors;
      }

      if (callback) {
        callback();
      }

      return {};
    } catch (error) {
      return { error };
    }
  }

  return {};
};

export default handleUpdatePostSubmitQuestionnaire;
